const showNavbar = open => dispatch => {
  dispatch({
    type: "SHOW_NAVBAR",
    payload: open,
  });
};

export default showNavbar;



// WEBPACK FOOTER //
// ./src/actions/NavbarWrapperAction.js